import PermissionListComponent from "./PermissionListComponent.vue";
import PermissionListSearchComponent from "./PermissionListSearchComponent.vue";

const PERMISSION_SEARCH_CHANGED_EVENT = "permissions-search-changed-event";

export { PermissionListComponent, PermissionListSearchComponent, PERMISSION_SEARCH_CHANGED_EVENT };
